import React from 'react';
import T from 'prop-types';
import {SidePanel} from 'routes/App/cashback/styles';

const MomentumPanel = ({customersEarnedCredits}) => {
  return (
    <SidePanel>
      <h4 className='panelTitle'>Building momentum</h4>
      <div className='panelBody'>
        <b className='yellow'>{customersEarnedCredits || 0} customers</b> have
        earned credits so far. As they come back to redeem, you&apos;ll see the
        impact here.
      </div>
    </SidePanel>
  );
};

MomentumPanel.propTypes = {
  customersEarnedCredits: T.number
};

MomentumPanel.defaultProps = {
  customersEarnedCredits: 0
};

export default MomentumPanel;
